// @flow
import client, { saveJWTToken } from '../../client'

// API Endpoint
export const SSO_LOGIN_ENDPOINT = '/auth/users/sso-login/'

/**
 * SSO Login user with encrypted user id
 * @param {Object} data User information
 * @param {string} data.key Encrypted User ID
 * @return {Promise|Error} A resolved Promise with the server response or Rejected with an Error
 */
export const ssoLogin = (data: { key: string }): Promise<any> =>
  client
    .post(SSO_LOGIN_ENDPOINT, {
      body: { ...data },
    })
    .then(saveJWTToken)

export default ssoLogin
